import $ from 'cash-dom';

export default function initPopup(opts) {
  if (WHEEL_SETTINGS) {
    opts = Object.assign({}, WHEEL_SETTINGS, opts || {});
  }
  console.log(opts);
  var form = opts.Wheel.form;
  const Wheel = opts.Wheel;
  const scheme = Wheel.scheme;
  const {
    logo,
    show_popup,
    guide,
    policy,
  } = opts.SETTINGS;
  const imgShowPopup = show_popup ? `<img src="${show_popup}" alt="">` : `<img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/woay-of-popup.png" alt="">`;
  const guidePopup = guide ? guide : '';
  const policyPopup = policy ? policy : '';
  const templateQuick = `<div id="btn-show-popup">${imgShowPopup}</div>
      <div id="w-popup-section" style="display:none">
        <div id="w-popup-container">
            <button w-role="close_button" class="modal__close w-popup-close-btn" aria-label="Close modal">×</button>
            <button w-role="close_button" class="modal__close w-popup-remove-anim" aria-label="Close modal">×</button>
            <div w-role="close_button" class="w-close-popup" aria-label="Close modal">
                <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/arrow-right.png">
                Đóng popup
            </div>
            <div class="box-game">
                <div id="vongquaymayman"></div>
                <button id="w-play-game">Chơi ngay!</button>
            </div>
            <div class="logo-popup w-box-img">
                <img class="award-image" src="${logo}">
            </div>
            <div id="w-popup-userinfo-form">
                <h4>Bổ sung thông tin</h4>
                <div w-role="form" class="style-1">
            </div>
            <button id="w-popup-userinfo-form-submit-btn">THỬ ĐỘ MAY MẮN</button>
        </div>
        <div id="w-popup-reward">
            <div class="title-voucher sub-title hide-badluck">Chúc mừng bạn đã trúng</div>
            <div class="title-big title-popup"></div>
            <div class="voucher-content text-tutorial" style="margin-bottom: 10px;">
            </div>
            <div class="input-code copy-code hide-badluck">
                <input type="text" id="w-text-code" class="code" value="unknow" aria-label="Code Prize" readonly="readonly">
            </div>
            <div class="copy-success">Coupon copied!</div>
            <div id="btn-copy-code" class="btn-copy btn-copy-code hide-badluck" aria-label="Copy mã">Copy mã!</div>
        </div>
        <div id="w-popup-out-of-turn">
          <div class="title-big title-popup">Bạn đã hết lượt chơi</div>
        </div>
        </div>
        <div id="w-popup-close"></div>
    </div>`
  const templateTour = `<div id="btn-show-popup">${imgShowPopup}</div>
  <div id="w-popup-section" style="display:none">
    <div id="w-popup-container">
        <div w-role="close_button" class="w-close-popup hidden-mobile" aria-label="Close modal">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/arrow-right-2.png">
          Đóng popup
        </div>
        <div w-role="close_button" class="w-close-popup hidden-desktop" aria-label="Close modal">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/close.png" alt="">
        </div>
      <div class="fab-wrapper fab-wrapper-2 hidden-mobile">
        <input id="fabCheckbox2" type="checkbox" class="fab-checkbox" />
        <label class="fab" for="fabCheckbox2">
          <span class="fab-dots fab-dots-1"></span>
          <span class="fab-dots fab-dots-2"></span>
          <span class="fab-dots fab-dots-3"></span>
        </label>
        <div class="fab-wheel fab-wheel-2">
          <div class="fab-action fab-action-1 btn-play-game">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/play-game.png">
            </div>
            <span>Chơi game</span>
          </div>
          <div class="fab-action fab-action-2 btn-turn">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/heart.png">
            </div>
            <span>Thêm lượt</span>
          </div>
          <div class="fab-action fab-action-3 btn-rank">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/rank.png">
            </div>
            <span>Xếp hạng</span>
          </div>
          <div class="fab-action fab-action-4 btn-policy">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/faq.png">
            </div>
            <span>Thể lệ</span>
          </div>
        </div>
      </div>
      <div class="d-lg-none">
        <div class="m-menu-mobile">
            <div class="btn-main-woay btn-play-game active">
              <div class="box-img">
                <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/play-game.png">
              </div>
              Chơi game
            </div>
            <div class="btn-main-woay btn-turn">
              <div class="box-img">
                <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/heart.png">
              </div>
              Thêm lượt
            </div>
            <div class="btn-main-woay btn-rank">
              <div class="box-img">
                <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/rank.png">
              </div>
              Xếp hạng
            </div>
            <div class="btn-main-woay btn-policy">
              <div class="box-img">
                <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/faq.png">
              </div>
              Thể lệ
            </div>
        </div>
      </div>
      <div class="section box-game active">
        <div id="vongquaymayman"></div>
        <div class="total-point">Tổng điểm của tôi: <span class="your-point"></span></div>
      </div>
      <div class="section section-mission box-600">
        <ul id="mission-list"></ul>
      </div>
      <div class="section box-rank tabs box-600">
            <div class="box-shading">
              <div class="box-icon">
                  <img src="https://working.woay.vn/assets/mission/star_1.png" alt="Icon bxh">
                </div>
                <div class="title-rank">Bảng xếp hạng</div>
              <ul class="tab-links wrap-item-button">
              <li class="item-button">
                  <a data-target="thang" class="tablinks active">Chung cuộc</a>
              </li>
              </ul>
            </div>
          <div class="wrap-bxh tab-content pd-box">
                <div class="tabcontent active" id="thang">
                <div style="text-align: center; padding: 15px; background-color: #fff">Hiện chưa có dữ liệu</div>
              </div>
          </div>
      </div>
      <div class="section list-reward box-600">
          <div class="d-flex align-center box-title box-shading">
            <div class="box-img">
              <img src="https://working.woay.vn/assets/mission/shop-coins3.png" alt="">
            </div>
            <div class="title-reward">Kho phần thưởng hiện vật</div>
          </div>
            <ul id="history" class="pd-box">
            <div style="text-align: center; padding: 15px">Hiện chưa có vật phẩm nào</div>
            </ul>
      </div>
      <div class="section list-point box-600">
        <div class="d-flex align-center box-title box-shading">
          <div class="box-img">
            <img src="https://working.woay.vn/assets/mission/shop-coins2.png" alt="">
          </div>
          <div class="title-reward">Lịch sử chơi</div>
        </div>
        <ul id="your-point" class="pd-box">
          <div style="text-align: center; padding: 15px">Hiện chưa có điểm</div>
        </ul>
      </div>
      <div class="section w-tab-ctn box-600">
        <ul class="nav nav-tabs nav-tabs-main primary-background" id="wTab" role="tablist">
          <li class="nav-item border-r active">
            <a class="nav-link" id="huongdanthamgia-tab" target="_self"
              onclick="openTab('huongdanthamgia')">HƯỚNG DẪN THAM GIA</a>
          </li>
          <li class="nav-item border-r">
            <a class="nav-link" id="dieukienapdung-tab" target="_self" onclick="openTab('dieukienapdung')">ĐIỀU KIỆN ÁP DỤNG</a>
          </li>
        </ul>
        <div class="tab-content tab-content-main" id="wTabContent">
          <div class="tab-pane active in style-8" id="huongdanthamgia" role="tabpanel"
            aria-labelledby="huongdanthamgia-tab">
            ${guidePopup}
          </div>
          <div class="tab-pane style-8" id="dieukienapdung" role="tabpanel" aria-labelledby="dieukienapdung-tab"
            style="text-align: left; color: black;">
            ${policyPopup}
          </div>
        </div>
      </div>
    </div>
  </div>
      <script>
      var randomUser = {}
    </script>
      <script type="text/x-tmpl" id="d-mission-tmpl">
        <li class="mission-{%= o.name %}">
            <div class="box-img">
                <img src="{%= o.image %}" alt="">
            </div>
            <div class="box-info">
                <h5>{%= o.title %}</h5>
                <p class="desc">{%= o.description %}</p>
            </div>
            <div class="btn-challenge">
                {% if (o.name === 'share_facebook') { %}
                  <a class="bg-button-group color-button-group btn-share-fb">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else if (o.name === 'invite_friend') { %}
                  <a class="bg-button-group color-button-group btn-invite-friend">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else if (o.name === 'wiki') { %}
                  <a class="bg-button-group color-button-group btn-show-quiz">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else if (o.name === 'explore_store') { %}
                  <a class="bg-button-group color-button-group btn-show-qrcode">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else { %}
                  <a class="bg-button-group color-button-group" onclick="missionComplete('{%= o.name %}')">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } %}
            </div>
        </li>
      </script>
      <script type="text/x-tmpl" id="m-mission-tmpl">
        <li class="mission-{%= o.name %} m-challenge">
            <div class="flex-box">
              <div class="box-img">
                <img src="{%= o.image %}" alt="">
              </div>
              <div class="box-right">
                <div class="box-info">
                  <h5>{%= o.title %}</h5>
                </div>
                <div class="meta">
                  <p class="desc">{%= o.description %}</p>
                </div>
                <div class="btn-challenge">
                {% if (o.name === 'share_facebook') { %}
                  <a class="bg-button-group color-button-group btn-share-fb">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else if (o.name === 'invite_friend') { %}
                  <a class="bg-button-group color-button-group btn-invite-friend">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else if (o.name === 'wiki') { %}
                  <a class="bg-button-group color-button-group btn-show-quiz">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else if (o.name === 'explore_store') { %}
                  <a class="bg-button-group color-button-group btn-show-qrcode">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } else { %}
                  <a class="bg-button-group color-button-group" onclick="missionComplete('{%= o.name %}')">
                    <img src="https://working.woay.vn/assets/mission/button-status-1.png">
                  </a>
                {% } %}
              </div>
            </div>
          </div>  
        </li>
      </script>
      <script type="text/x-tmpl" id="question-tmpl">
        <div class="list-question">
          {% for (var i = 0; i < o.answer.length; i++) { %}
            <div class="item-question">
              {%= o.answer[i] %}
              <input type="radio" name="answer" value="{%= i %}">
              <span class="checkmark"><img src="settings.mission_img_check" alt=""></<span>
            </div>
          {% } %}
          {% if (!o.answer.length) { %}
            <div class="item-question" style="display: none"></div>
          {% } %}
        </div
      </script>
      <script type="text/x-tmpl" id="highscore-tmpl">
          <div class="box-rank">
              <ul class="bg-white">
                  {% if (!o || !o.length) { %}
                    <div style="text-align: center; padding: 15px">Hiện chưa có dữ liệu</div>
                  {% } %}
                  {% for (var i = 0; i < o.length; i++) { %}
                      <li class="rank-item" {%= o[i].activeClass %}>
                          <div class="item-index">{%= o[i].stt %}</div>
                          <div class="item-name">{%= o[i].name %}</div>
                          <div class="item-point">{%= o[i].point %}</div>
                      </li>
                  {% } %}
              </ul>
          </div>
      </script>
      <script type="text/x-tmpl" id="my-score-tmpl">
          <li class="item-score">
            <div class="d-flex align-center justify-center flex-col">
              <div class="item-point">{%= o.value %} điểm</div>
              <div class="item-time">{%= o.created_at %}</div>
            </div>
            <div class="item-type">{%= o.type %}</div>
          </li>
      </script>
    </div>`
  const templateMixed = `<div id="btn-show-popup">${imgShowPopup}</div>
  <div id="w-popup-section" style="display:none">
    <div id="w-popup-container">
        <div w-role="close_button" class="w-close-popup hidden-mobile" aria-label="Close modal">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/arrow-right-2.png">
          Đóng popup
        </div>
        <div w-role="close_button" class="w-close-popup hidden-desktop" aria-label="Close modal">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/close.png" alt="">
        </div>
      <div class="fab-wrapper fab-wrapper-2 hidden-mobile">
        <input id="fabCheckbox2" type="checkbox" class="fab-checkbox" />
        <label class="fab" for="fabCheckbox2">
          <span class="fab-dots fab-dots-1"></span>
          <span class="fab-dots fab-dots-2"></span>
          <span class="fab-dots fab-dots-3"></span>
        </label>
        <div class="fab-wheel fab-wheel-2">
          <div class="fab-action fab-action-1 btn-play-game">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/play-game.png">
            </div>
            <span>Chơi game</span>
          </div>
          <div class="fab-action fab-action-2 btn-turn">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/heart.png">
            </div>
            <span>Thêm lượt</span>
          </div>
          <div class="fab-action fab-action-3 btn-history">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/reward.png">
            </div>
            <span>Kho quà</span>
          </div>
          <div class="fab-action fab-action-4 btn-rank">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/rank.png">
            </div>
            <span>Xếp hạng</span>
          </div>
          <div class="fab-action fab-action-5 btn-policy">
            <div class="fab-img">
              <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/faq.png">
            </div>
            <span>Thể lệ</span>
          </div>
        </div>
      </div>
    <div class="d-lg-none">
    <div class="m-menu-mobile">
        <div class="btn-main-woay btn-play-game active">
        <div class="box-img">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/play-game.png">
        </div>
        Chơi game
        </div>
        <div class="btn-main-woay btn-turn">
        <div class="box-img">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/heart.png">
        </div>
        Thêm lượt
        </div>
        <div class="btn-main-woay btn-history">
        <div class="box-img">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/reward.png">
        </div>
        Kho quà
        </div>
        <div class="btn-main-woay btn-rank">
        <div class="box-img">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/rank.png">
        </div>
        Xếp hạng
        </div>
        <div class="btn-main-woay btn-policy">
        <div class="box-img">
          <img src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/faq.png">
        </div>
        Thể lệ
        </div>
    </div>
    </div>
    <div class="section box-game active">
      <div id="vongquaymayman"></div>
      <div class="total-point">Tổng điểm của tôi: <span class="your-point"></span></div>
    </div>
    <div class="section section-mission box-600">
      <ul id="mission-list"></ul>
    </div>
    <div class="section box-rank tabs box-600">
          <div class="box-shading">
            <div class="box-icon">
                <img src="https://working.woay.vn/assets/mission/star_1.png" alt="Icon bxh">
              </div>
              <div class="title-rank">Bảng xếp hạng</div>
            <ul class="tab-links wrap-item-button">
            <li class="item-button">
                <a data-target="thang" class="tablinks active">Chung cuộc</a>
            </li>
            </ul>
          </div>
        <div class="wrap-bxh tab-content pd-box">
              <div class="tabcontent active" id="thang">
              <div style="text-align: center; padding: 15px; background-color: #fff">Hiện chưa có dữ liệu</div>
            </div>
        </div>
    </div>
    <div class="section list-reward box-600">
        <div class="d-flex align-center box-title box-shading">
          <div class="box-img">
            <img src="https://working.woay.vn/assets/mission/shop-coins3.png" alt="">
          </div>
          <div class="title-reward">Kho phần thưởng hiện vật</div>
        </div>
          <ul id="history" class="pd-box">
          <div style="text-align: center; padding: 15px">Hiện chưa có vật phẩm nào</div>
          </ul>
    </div>
    <div class="section list-point box-600">
      <div class="d-flex align-center box-title box-shading">
        <div class="box-img">
          <img src="https://working.woay.vn/assets/mission/shop-coins2.png" alt="">
        </div>
        <div class="title-reward">Lịch sử chơi</div>
      </div>
      <ul id="your-point" class="pd-box">
        <div style="text-align: center; padding: 15px">Hiện chưa có điểm</div>
      </ul>
    </div>
    <div class="section w-tab-ctn box-600">
      <ul class="nav nav-tabs nav-tabs-main primary-background" id="wTab" role="tablist">
        <li class="nav-item border-r active">
          <a class="nav-link" id="huongdanthamgia-tab" target="_self"
            onclick="openTab('huongdanthamgia')">HƯỚNG DẪN THAM GIA</a>
        </li>
        <li class="nav-item border-r">
          <a class="nav-link" id="dieukienapdung-tab" target="_self" onclick="openTab('dieukienapdung')">ĐIỀU KIỆN ÁP DỤNG</a>
        </li>
      </ul>
      <div class="tab-content tab-content-main" id="wTabContent">
        <div class="tab-pane active in style-8" id="huongdanthamgia" role="tabpanel"
          aria-labelledby="huongdanthamgia-tab">
          ${guidePopup}
        </div>
        <div class="tab-pane style-8" id="dieukienapdung" role="tabpanel" aria-labelledby="dieukienapdung-tab"
          style="text-align: left; color: black;">
          ${policyPopup}
        </div>
      </div>
    </div>
  </div>
  </div>
  <script>
  var randomUser = {}
</script>
<script type="text/x-tmpl" id="d-mission-tmpl">
  <li class="mission-{%= o.name %}">
      <div class="box-img">
          <img src="{%= o.image %}" alt="">
      </div>
      <div class="box-info">
          <h5>{%= o.title %}</h5>
          <p class="desc">{%= o.description %}</p>
      </div>
      <div class="btn-challenge">
          {% if (o.name === 'share_facebook') { %}
            <a class="bg-button-group color-button-group btn-share-fb">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else if (o.name === 'invite_friend') { %}
            <a class="bg-button-group color-button-group btn-invite-friend">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else if (o.name === 'wiki') { %}
            <a class="bg-button-group color-button-group btn-show-quiz">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else if (o.name === 'explore_store') { %}
            <a class="bg-button-group color-button-group btn-show-qrcode">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else { %}
            <a class="bg-button-group color-button-group" onclick="missionComplete('{%= o.name %}')">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } %}
      </div>
  </li>
</script>
<script type="text/x-tmpl" id="m-mission-tmpl">
  <li class="mission-{%= o.name %} m-challenge">
      <div class="flex-box">
        <div class="box-img">
          <img src="{%= o.image %}" alt="">
        </div>
        <div class="box-right">
          <div class="box-info">
            <h5>{%= o.title %}</h5>
          </div>
          <div class="meta">
            <p class="desc">{%= o.description %}</p>
          </div>
          <div class="btn-challenge">
          {% if (o.name === 'share_facebook') { %}
            <a class="bg-button-group color-button-group btn-share-fb">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else if (o.name === 'invite_friend') { %}
            <a class="bg-button-group color-button-group btn-invite-friend">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else if (o.name === 'wiki') { %}
            <a class="bg-button-group color-button-group btn-show-quiz">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else if (o.name === 'explore_store') { %}
            <a class="bg-button-group color-button-group btn-show-qrcode">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } else { %}
            <a class="bg-button-group color-button-group" onclick="missionComplete('{%= o.name %}')">
              <img src="https://working.woay.vn/assets/mission/button-status-1.png">
            </a>
          {% } %}
        </div>
      </div>
    </div>  
  </li>
</script>
<script type="text/x-tmpl" id="question-tmpl">
  <div class="list-question">
    {% for (var i = 0; i < o.answer.length; i++) { %}
      <div class="item-question">
        {%= o.answer[i] %}
        <input type="radio" name="answer" value="{%= i %}">
        <span class="checkmark"><img src="settings.mission_img_check" alt=""></<span>
      </div>
    {% } %}
    {% if (!o.answer.length) { %}
      <div class="item-question" style="display: none"></div>
    {% } %}
  </div
</script>
<script type="text/x-tmpl" id="highscore-tmpl">
    <div class="box-rank">
        <ul class="bg-white">
            {% if (!o || !o.length) { %}
              <div style="text-align: center; padding: 15px">Hiện chưa có dữ liệu</div>
            {% } %}
            {% for (var i = 0; i < o.length; i++) { %}
                <li class="rank-item" {%= o[i].activeClass %}>
                    <div class="item-index">{%= o[i].stt %}</div>
                    <div class="item-name">{%= o[i].name %}</div>
                    <div class="item-point">{%= o[i].point %}</div>
                </li>
            {% } %}
        </ul>
    </div>
</script>
<script type="text/x-tmpl" id="my-score-tmpl">
    <li class="item-score">
      <div class="d-flex align-center justify-center flex-col">
        <div class="item-point">{%= o.value %} điểm</div>
        <div class="item-time">{%= o.created_at %}</div>
      </div>
      <div class="item-type">{%= o.type %}</div>
    </li>
</script>
<script type="text/x-tmpl" id="history-tmpl">
  <li class="item-reward">
    <div class="box-icon">
      <img src="https://working.woay.vn/assets/mission/game-icon1.png" alt="Hình phần thưởng">
    </div>
    <div class="d-flex align-center justify-center flex-col pl-2">
      <div class="item-name">{%= o.item_name %}</div>
      <div class="item-time">{%= o.updated_at %}</div>
    </div>
    <div class="sku">
      <a>{%= o.code %}</a>
    </div>
  </li>
</script>
    </div>`
  if (!$('#w-popup-section').length) {
    let popupHTML = false;

    if (scheme == 'quick') {
      popupHTML = templateQuick;
      console.log('quick');
      setTimeout(function () {
        $('#w-popup-section').addClass('s-tour');
      }, 10)
    }

    if (scheme == 'tour') {
      popupHTML = templateTour;
      console.log('tour');
      setTimeout(function () {
        $('#w-popup-section').addClass('s-tour');
      }, 10)
    }

    if (scheme == 'mixed') {
      popupHTML = templateMixed;
      console.log('mixed');
      setTimeout(function () {
        $('#w-popup-section').addClass('s-mixed');
      }, 10)
    }

    if (Wheel.is_test_mode) {
      setTimeout(function () {
        $('#w-popup-section').addClass('p-test-mode');
      }, 10)
    } else {
      setTimeout(function () {
        $('#w-popup-section').removeClass('p-test-mode');
      }, 10)
    }

    if (!popupHTML) return;

    $('body').append(popupHTML)
  }

  if (!isMobile()) {
    console.log('desktop mode');
    $('#w-popup-section').addClass('desktop-mode');
  } else {
    console.log('mobile-mode');
    $('#w-popup-section').removeClass('desktop-mode');
  }
  const keys = [
    "name",
    "phone",
    "email",
    "address",
    "identity",
    "province",
    "district",
    "custom_1",
    "custom_2",
    "custom_3",
    "custom_4",
    "custom_5",
    "custom_6",
    "custom_7",
    "custom_8",
    "custom_9",
    "password",
  ];
  const fields = [];
  for (var key of keys) {
    if (!form[key] || !form[key].enabled) continue;
    form[key].key = key;
    fields.push(form[key]);
  }

  if (scheme == 'quick') {
    createForm($('#w-popup-section').find('[w-role=form]'), fields);
  }

  function createForm($form, form) {
    for (var field of form) {
      const inputTag = parseInputTag(field);
      $form.append(`<div class="w-form-group floating ${field.key}">
                    <div class="d-flex align-center">
                        <img class="icon-form" src="https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/calendar.png">
                        ${inputTag}
                        ${field.required ? '<span class="w-required">*</span>' : ""}
                        <div class="w-error-log">Vui lòng nhập đủ thông tin</div>
                    </div>
                </div>`)
      if (field.key == 'phone' && field.enabled) {
        let input = document.querySelector('input[data-filter]');
        let state = {
          value: input.value,
          start: input.selectionStart,
          end: input.selectionEnd,
          pattern: RegExp('^' + input.dataset.filter + '$')
        };

        input.addEventListener('input', event => {
          if (state.pattern.test(input.value)) {
            state.value = input.value;
          } else {
            input.value = state.value;
            input.setSelectionRange(state.start, state.end);
          }
        });

        input.addEventListener('keydown', event => {
          state.start = input.selectionStart;
          state.end = input.selectionEnd;
        });
      }
      if (field.key == 'name' && field.enabled) {
        $('.w-form-group.name .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/user.png');
      }
      if (field.key == 'phone' && field.enabled) {
        $('.w-form-group.phone .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/smartphone.png');
      }
      if (field.key == 'email' && field.enabled) {
        $('.w-form-group.email .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/mail.png');
      }
      if (field.key == 'address' && field.enabled) {
        $('.w-form-group.address .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/map-pin.png');
      }
      if (field.key == 'province' && field.enabled) {
        $('.w-form-group.province .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/map-pin.png');
      }
      if (field.key == 'district' && field.enabled) {
        $('.w-form-group.district .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/map-pin.png');
      }
      if (field.key == 'identity' && field.enabled) {
        $('.w-form-group.email .icon-form').attr('src', 'https://cdn.jsdelivr.net/gh/woayst/common@1.6.18/images/icon.png');
      }
      $('.w-form-group label').each(function () {
        var textSize = $(this).text().length;
        if (textSize > 35) {
          $(this).addClass('overtype');
          $(this).parent().addClass('oversize');
        }
      });
    }

    $form.find('input, select')
      .on('focus', function () {
        $(this).parent().removeClass('error');
      })
  }

  function parseInputTag(field) {
    if (field.type != 'select') {
      const type = getInputType(field.key);
      if (field.key == 'phone') {
        return `<input 
                type="${type}" placeholder="Vui lòng nhập ${field.name}" data-filter='([\+]|([\+][1-9])?[0-9]*)'
                class="w-${field.key}" name="${field.key}" 
                data-name="${field.name}"  ${field.required ? 'required' : ''}></input>`;
      }
      return `<input 
                type="${type}" placeholder="Vui lòng nhập ${field.name}"
                class="w-${field.key}" name="${field.key}" 
                data-name="${field.name}"  ${field.required ? 'required' : ''}></input>`;
    }

    // SELECT
    let html = `<select class="w-form-control w-${field.key}" data-name="${field.name}" name="${field.key}"
            ${field.required ? "required" : ""}/>`;
    if (field.key !== 'province' && field.key !== 'district') {
      if (field.options) {
        html += `<option value=""></option>`;
        var options = field.options.split(',');
        options.forEach(function (option) {
          html += `<option value="${option}">${option}</option>`
        })
      }
    }
    html += '</select>';
    return html;
  }

  function validateForm(formId) {
    let error = false;

    $(`#${formId} input, #${formId} select`).each((i, e) => {
      $(e).data('error', '');
      $(e).parent().removeClass('error');
      if ($(e).val()) {
        var curVal = $(e).val().toString().trim().replace(/[\x00-\x1F\x7F-\x9F]/g, "");
      }
      if (!curVal && $(e)[0].required) {
        let action = 'nhập';
        if ($(e)[0].tagName === 'SELECT') {
          action = 'chọn';
        }
        $(e).parent().addClass('error');
        error = `Vui lòng ${action} ${$(e).data('name')}`;
        $(e).siblings('.w-error-log').html(error);
        $(e).data('error', error);
        return error;
      }
    })
    return error
  }

  function getInputType(k) {
    if (k == 'phone' || k == 'tel') return 'tel';
    if (k == 'email') return 'email';
    if (k == 'number') return 'number';
    return 'text';
  }

  // TODO: Move ra chỗ khác
  var submit_btn = SETTINGS.submit_btn || {};
  var button_1 = SETTINGS.btn_1 || {};
  var button_2 = SETTINGS.btn_2 || {};
  $('.voucher-content').append(SETTINGS.voucher_apply);

  $('#w-btn-left').html(button_1.title)
    .css({
      'color': button_1.title,
      'background-color': button_1.background,
      'display': button_1.active ? 'block' : 'none'
    })
    .attr('href', button_1.url);
  $('#w-btn-right').html(button_2.title)
    .css({
      'color': button_2.color,
      'background-color': button_2.background,
      'display': button_2.active ? 'block' : 'none'
    })
    .attr('href', button_2.url);


  if (SETTINGS.logo) {
    $('.award-image').each(function (index, image) {
      $(image).attr('src', SETTINGS.logo);
    })
  }
  $('#w-popup-container').css('background-color', SETTINGS.background_color);
  $('#w-popup-userinfo-form-submit-btn').html(submit_btn.title).css({
    'color': submit_btn.color,
    'background-color': submit_btn.background
  });

  function closePopup() {
    $('#w-popup-section').css({
      'opacity': 0,
      'visibility': 'hidden'
    })
    $('#w-popup-container').css('left', '-200%');
    $('#w-popup-close').css('display', 'none');
    $('.sound-control').css('display', 'none');
  }

  function isMobile() {
    if (window.innerWidth >= 991) {
      console.log('false');
      return false;
    }
    console.log('true');
    return true;
  }


  function openPopup() {
    $('#w-popup-section').css({
      'opacity': 1,
      'visibility': 'visible',
      'display': 'block'
    })
    $('#w-popup-container').css('left', 0);
    $('#w-popup-close').css('display', 'block');
    $('.sound-control').css('display', 'block');
  }

  function showReward() {
    $('#w-popup-userinfo-form').css({
      'display': 'none',
      'visibility': 'hidden'
    })
    $('#w-popup-out-of-turn').css({
      'display': 'none',
      'visibility': 'hidden'
    })
    $('#w-popup-reward').css({
      'display': 'block',
      'visibility': 'visible'
    })
  }

  function hideReward() {
    $('#w-popup-reward').css({
      'display': 'none',
      'visibility': 'hidden'
    })
    $('#w-popup-userinfo-form').css({
      'display': 'block',
      'visibility': 'visible'
    })
    $('#w-popup-out-of-turn').css({
      'display': 'none',
      'visibility': 'hidden'
    })
  }

  function showOutOfTurn() {
    $('#w-popup-userinfo-form').css({
      'display': 'none',
      'visibility': 'hidden'
    })
    $('#w-popup-reward').css({
      'display': 'none',
      'visibility': 'hidden'
    })
    $('#w-popup-out-of-turn').css({
      'display': 'block',
      'visibility': 'visible'
    })
  }

  function hideOutOfTurn() {
    $('#w-popup-reward').css({
      'display': 'none',
      'visibility': 'hidden'
    })
    $('#w-popup-userinfo-form').css({
      'display': 'block',
      'visibility': 'visible'
    })
    $('#w-popup-out-of-turn').css({
      'display': 'none',
      'visibility': 'hidden'
    })
  }

  function addAnimWoay() {
    if (isMobile()) {
      $('#w-popup-container').addClass('anim-woay');
      $('#w-popup-container .w-popup-close-btn').css('display', 'none');
      $('#w-popup-container .w-popup-remove-anim').css('display', 'block');
    }
  }

  function hideAnimWoay() {
    if (isMobile()) {
      $('#w-popup-container').removeClass('anim-woay');
      $('#w-popup-container .w-popup-close-btn').css('display', 'block');
      $('#w-popup-container .w-popup-remove-anim').css('display', 'none');
    }
  }
  return {
    close: closePopup,
    open: openPopup,
    showReward,
    hideReward,
    showOutOfTurn,
    hideOutOfTurn,
    addAnimWoay,
    hideAnimWoay,
    validateForm,
  }
}